import { initializeApp } from "firebase/app";
import "firebase/database";
import { getAuth,
    signInWithEmailAndPassword,
    signOut,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail as _sendPasswordResetEmail,
} from "firebase/auth";
import { getFirebaseEnvVar } from "utils/env";

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: getFirebaseEnvVar("API_KEY"),
    authDomain: getFirebaseEnvVar("AUTH_DOMAIN"),
    databaseURL: getFirebaseEnvVar("DATABASE_URL"),
    projectId: getFirebaseEnvVar("PROJECT_ID"),
    storageBucket: getFirebaseEnvVar("STORAGE_BUCKET"),
    messagingSenderId: getFirebaseEnvVar("MESSAGING_SENDER_ID"),
    appId: getFirebaseEnvVar("APP_ID"),
    measurementId: getFirebaseEnvVar("MEASUREMENT_ID"),
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth
const auth = getAuth(app);

export const login = (email, password) => signInWithEmailAndPassword(auth, email, password);

export const logout = () => signOut(auth);

export const settings = (name) => app.database().ref("settings").child(name);

export const signUp = (email, password) => createUserWithEmailAndPassword(auth, email, password);

export const sendPasswordResetEmail = (email) => _sendPasswordResetEmail(auth, email);

export const management = (name) => app.database().ref("management").child(name);

export const modules = (name) => app.database().ref("modules").child(name);

export default app;
